import {
  AUDIT_ENTITY_UNIT_MAIN_STATE_TYPE_ID_LOOKUP,
  AUDIT_ENTITY_UNIT_STATUS_LOOKUP,
  AUDIT_ENTITY_UNIT_THEME_ID_LOOKUP,
  AUDIT_ENTITY_UNIT_TYPE_ID_LOOKUP
} from '../constants';

// Audit Entity Utils
export const resolveUnitsIntlLookUp = (intl: any, value: string, i18nLookup: string): string => {
  switch (i18nLookup) {
    case AUDIT_ENTITY_UNIT_MAIN_STATE_TYPE_ID_LOOKUP:
      return intl.formatMessage({ id: `units.mainStateId.${value}` });
    case AUDIT_ENTITY_UNIT_STATUS_LOOKUP:
      return intl.formatMessage({ id: `trackingUnits.unitStatus${value}` });
    case AUDIT_ENTITY_UNIT_THEME_ID_LOOKUP:
      return intl.formatMessage({ id: `units.theme${value}` });
    case AUDIT_ENTITY_UNIT_TYPE_ID_LOOKUP:
      return intl.formatMessage({ id: `trackingUnits.unitType${value}` });
    default:
      return '';
  }
};
